import { Section, Chapter, Reveal } from "./Section";
import { GraduationCap, Church, Crown } from "lucide-react";

const TIMELINE = [
  ["Newark, NJ", "Born in Newark, New Jersey — ministry foundation formed in the Baptist tradition, where his grandmother hosted weekly Friday-night tarrying services seeking the presence and power of the Holy Spirit."],
  ["Age 11", "Introduced to the Pentecostal and Apostolic faith and received the gift of the Holy Spirit."],
  ["Age 17", "Answered the call to ministry — beginning a journey that has now spanned four decades."],
  ["Today", "Pastor, prophet, teacher, national evangelist, life coach, motivational speaker, and mentor — having pastored three churches and traveled extensively throughout the United States."],
];

const CREDENTIALS = [
  "Founder, The Kingdom Worship Center",
  "CEO, Kingdom Associates LLC",
  "Pastor, Kingdom Outreach Community Worship Center — Newark, NJ",
  "Certified Herbalist",
  "Student, Naturopathic Holistic Practice",
];

export default function About() {
  return (
    <Section id="about" testid="about-section">
      <Chapter number="01" label="Meet Prophet Terrell Turner" testid="about-chapter"
        title={<>40 Years of Ministry.<br /><span className="text-vg">A Lifetime of Kingdom Impact.</span></>} />

      <div className="mt-16 grid lg:grid-cols-12 gap-14 items-start">
        <Reveal className="lg:col-span-5" delay={0.1}>
          <div className="relative group">
            <div aria-hidden className="absolute -inset-5 rounded-[2.5rem] bg-gradient-to-br from-violet-600/20 to-amber-500/15 blur-2xl opacity-70 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="glow-frame">
              <div className="relative overflow-hidden rounded-[1.7rem] bg-gradient-to-b from-[#12141f] to-[#06070B]">
                <img src="/assets/prophet-cutout.png" alt="Prophet Terrell Turner" data-testid="about-portrait"
                  className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
              </div>
            </div>
            <div className="mt-6 flex flex-wrap gap-2">
              {["Prophet", "Pastor", "Teacher", "Evangelist", "Life Coach", "Mentor"].map((role) => (
                <span key={role} className="glass px-3.5 py-2 rounded-full text-slate-200 font-mono text-xs uppercase tracking-[0.2em] hover:border-violet-400/50 hover:text-white transition-colors duration-300">{role}</span>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          {TIMELINE.map(([era, text], i) => (
            <Reveal key={era} delay={0.08 * i} className="relative pl-8 pb-8 border-l border-white/10 last:pb-0">
              <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-gradient-to-r from-violet-400 to-amber-400 shadow-[0_0_14px_rgba(139,92,246,0.8)]" />
              <p className="font-mono text-sm font-semibold uppercase tracking-[0.25em] text-vg">{era}</p>
              <p className="mt-2 text-base sm:text-lg text-slate-300 leading-relaxed font-normal">{text}</p>
            </Reveal>
          ))}

          <Reveal delay={0.2} className="mt-10 glow-frame">
            <div className="rounded-[1.7rem] bg-[#0B0E16] p-7">
              <p className="font-serif text-2xl sm:text-3xl text-slate-100 italic leading-relaxed">
                &ldquo;His mission: to equip people, strengthen leaders, develop Kingdom-minded individuals,
                proclaim truth with prophetic clarity, and help others fulfill their God-given potential.&rdquo;
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.25} className="mt-8 grid sm:grid-cols-2 gap-3">
            {CREDENTIALS.map((c) => (
              <div key={c} className="flex items-start gap-3 text-base text-slate-300">
                {c.startsWith("Founder") ? <Crown size={15} className="mt-0.5 shrink-0 text-amber-400" />
                  : c.startsWith("Pastor") || c.startsWith("CEO") ? <Church size={15} className="mt-0.5 shrink-0 text-violet-400" />
                  : <GraduationCap size={15} className="mt-0.5 shrink-0 text-cyan-400" />}
                <span>{c}</span>
              </div>
            ))}
            <p className="sm:col-span-2 mt-2 text-sm text-slate-400">
              Studied religion, theology, and psychology — Manhattan Bible Institute, Nyack College, Grand Canyon University.
            </p>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
